import { useEffect, useRef } from "react"
import { DeviceEventEmitter } from "~/ui/primitives"
import { useWebview, WEBVIEW_CLOSED_EVENT } from "~components/WebviewContext"

export { WEBVIEW_CLOSED_EVENT }

/** iframe / 钱包 WebView 关闭后刷新当前页数据 */
export function useWebviewClosedRefresh(onRefresh: () => void | Promise<void>) {
  const { webviewCloseSeq } = useWebview()
  const onRefreshRef = useRef(onRefresh)
  onRefreshRef.current = onRefresh
  const lastSeqRef = useRef(webviewCloseSeq)

  useEffect(() => {
    const run = () => {
      void onRefreshRef.current()
    }
    const sub = DeviceEventEmitter.addListener(WEBVIEW_CLOSED_EVENT, run)
    return () => sub.remove()
  }, [])

  useEffect(() => {
    if (webviewCloseSeq === lastSeqRef.current) return
    lastSeqRef.current = webviewCloseSeq
    if (webviewCloseSeq <= 0) return
    void onRefreshRef.current()
  }, [webviewCloseSeq])
}
